import React, { useState } from 'react'
import { Toast } from 'react-bootstrap'

const AlertMessage = ({ showAlertMessage, closeAlert, message = "" }) => {
    return (
        <div className="alert-div-wrapper" >
            <div className="alert-div">
                <Toast show={showAlertMessage} onClose={closeAlert} className="alert-message">
                    <Toast.Header>
                        <strong className="mr-auto">Interner Fehler&#33;</strong>
                    </Toast.Header>
                    <Toast.Body>{message != "" ? message : "Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator."}</Toast.Body>
                </Toast>
            </div>
        </div>
    )
}

export default AlertMessage

//const AlertMessage = ({ closeAlert, message } ) => {
//    return (
//        <Toast onClose={closeAlert} className="alert-message">
//            <Toast.Header>
//                <strong className="mr-auto">Interner Fehler&#33;</strong>
//            </Toast.Header>
//            <Toast.Body>
//                {message !== "" ? message
//                    : "Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator."}
//            </Toast.Body>
//        </Toast>
//    )
//}